document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-pill-gallery]").forEach((root) => {
    if (typeof Swiper === "undefined") {
      console.warn("Metaobject gallery: Swiper library not loaded.");
      return;
    }

    const mainSwiperEl = root.querySelector(".pill-gallery__main");

    const mainSwiper = new Swiper(mainSwiperEl, {
      loop: true,
      effect: "fade",
      fadeEffect: { crossFade: true },
      spaceBetween: 0,
      a11y: { enabled: true },
      keyboard: { enabled: true }
    });

    const hasPills = root.dataset.hasPills === "true";
    const pillButtons = [...root.querySelectorAll(".pill-gallery__pill")];
    const slideEls = [
      ...root.querySelectorAll(".pill-gallery__main .swiper-slide"),
    ];
    const thumbEls = [...root.querySelectorAll(".pill-gallery__thumb")];

    const handleize = (name) => {
      return name
        .toLowerCase()
        .replace(/[^\w\u00C0-\u024f]+/g, "-")
        .replace(/^-+|-+$/g, "");
    };

    const getVariantTitle = () => {
      const variantStarts = document.querySelector("variant-starts");
      if (!variantStarts || !variantStarts.currentVariant) return null;
      return variantStarts.currentVariant.options
        .map((opt) => handleize(String(opt).trim()))
        .join("|");
    };

    const getSlideAlt = (slideEl) => {
      const media = slideEl.querySelector("img, video");
      if (!media) return "";
      return (media.getAttribute("data-alt") || "")
        .toLowerCase()
        .replace("lalo2.0_", "");
    };

    const slideMatchesVariant = (slideEl, variantTitle) => {
      if (!variantTitle) return true;
      const alt = getSlideAlt(slideEl);
      if (!alt) return true;
      const altValues = alt.split(",").map((s) => s.trim());
      return altValues.includes(variantTitle) || alt === variantTitle;
    };

    let currentVariantTitle = null;
    let hasAnyVariantData = false;

    const getMatchingSlideIndices = () => {
      if (!hasAnyVariantData || !currentVariantTitle) {
        return slideEls.map((_, i) => i);
      }
      const matched = [];
      slideEls.forEach((slide, i) => {
        if (slideMatchesVariant(slide, currentVariantTitle)) {
          matched.push(i);
        }
      });
      return matched;
    };

    const goToSlide = (index) => {
      if (index >= 0 && index < slideEls.length) {
        mainSwiper.slideToLoop(index, 300);
      }
    };

    const scrollElementIntoView = (el, container, axis = "vertical") => {
      if (!el || !container) return;

      const elRect = el.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();

      if (axis === "horizontal") {
        const relativeLeft = elRect.left - containerRect.left;
        const elWidth = elRect.width;
        const containerWidth = containerRect.width;
        const scrollLeft = container.scrollLeft;

        if (relativeLeft < 0) {
          container.scrollLeft = scrollLeft + relativeLeft;
        } else if (relativeLeft + elWidth > containerWidth) {
          container.scrollLeft = scrollLeft + (relativeLeft + elWidth - containerWidth);
        }
      } else {
        const relativeTop = elRect.top - containerRect.top;
        const elHeight = elRect.height;
        const containerHeight = containerRect.height;
        const scrollTop = container.scrollTop;

        if (relativeTop < 0) {
          container.scrollTop = scrollTop + relativeTop;
        } else if (relativeTop + elHeight > containerHeight) {
          container.scrollTop = scrollTop + (relativeTop + elHeight - containerHeight);
        }
      }
    };

    const navigateSlides = (direction) => {
      const visible = getMatchingSlideIndices();
      if (visible.length <= 1) {
        if (visible.length === 1 && mainSwiper.realIndex !== visible[0]) {
          goToSlide(visible[0]);
        }
        return;
      }
      const current = mainSwiper.realIndex;
      let currentPos = visible.indexOf(current);
      if (currentPos === -1) {
        goToSlide(visible[0]);
        return;
      }
      let nextPos;
      if (direction === "next") {
        nextPos = (currentPos + 1) % visible.length;
      } else {
        nextPos = (currentPos - 1 + visible.length) % visible.length;
      }
      goToSlide(visible[nextPos]);
    };

    const applyVariantFilter = (variantTitle) => {
      currentVariantTitle = variantTitle;

      hasAnyVariantData = false;
      if (variantTitle) {
        for (let i = 0; i < slideEls.length; i++) {
          if (getSlideAlt(slideEls[i])) {
            hasAnyVariantData = true;
            break;
          }
        }
      }

      if (!hasAnyVariantData) {
        markGalleryReady();
        return;
      }

      const matchedIndices = getMatchingSlideIndices();
      const hasMatches = matchedIndices.length > 0;
      const thumbsContainer = root.querySelector(".pill-gallery__thumbs");

      thumbEls.forEach((thumb) => {
        const slideIndex = Number(thumb.dataset.slideIndex);
        const isActive = slideIndex === mainSwiper.realIndex;
        const isMatch = matchedIndices.includes(slideIndex);
        const show = isMatch || (hasMatches ? false : isActive);
        thumb.classList.toggle("is-visible", show);
        thumb.classList.toggle("is-active", isActive);
        if (isActive) {
          scrollElementIntoView(thumb, thumbsContainer, "vertical");
        }
      });

      if (hasMatches) {
        const currentAlt = getSlideAlt(slideEls[mainSwiper.realIndex]);
        const shouldNavigate =
          !matchedIndices.includes(mainSwiper.realIndex) || !currentAlt;

        if (shouldNavigate) {
          const firstRealMatch = matchedIndices.find((i) =>
            getSlideAlt(slideEls[i]),
          );
          goToSlide(
            firstRealMatch !== undefined ? firstRealMatch : matchedIndices[0],
          );
        }
      }

      markGalleryReady();
    };

    const revealGallery = () => {
      markGalleryReady();
    };

    const closeZoomOverlay = () => {
      if (window.zoomState && window.zoomState.currentOverlay) {
        window.zoomState.currentOverlay._cleanup();
        window.zoomState.currentOverlay = null;
      }
    };

    const nextArrow = root.querySelector(".pill-gallery__arrow--next");
    const prevArrow = root.querySelector(".pill-gallery__arrow--prev");

    if (nextArrow) {
      nextArrow.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeZoomOverlay();
        navigateSlides("next");
      });
    }
    if (prevArrow) {
      prevArrow.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeZoomOverlay();
        navigateSlides("prev");
      });
    }

    const variantStarts = document.querySelector("variant-starts");
    if (variantStarts) {
      variantStarts.addEventListener("change", () => {
        requestAnimationFrame(() => {
          const vTitle = getVariantTitle();
          applyVariantFilter(vTitle);
        });
      });
    }

    const getVideoInSlide = (slideEl) =>
      slideEl && slideEl.querySelector("[data-pill-gallery-video]");

    const setToggleState = (slideEl, isPlaying) => {
      const toggle =
        slideEl && slideEl.querySelector("[data-pill-gallery-video-toggle]");
      if (!toggle) return;
      toggle.classList.toggle("is-paused", !isPlaying);
      toggle.setAttribute("aria-pressed", String(!isPlaying));
      toggle.setAttribute(
        "aria-label",
        isPlaying ? "Pause video" : "Play video",
      );
    };

    const pauseAllVideos = () => {
      root.querySelectorAll("[data-pill-gallery-video]").forEach((video) => {
        video.pause();
        const slideEl = video.closest(".swiper-slide");
        setToggleState(slideEl, false);
      });
    };

    const playActiveVideoIfAny = () => {
      const activeSlideEl = mainSwiperEl.querySelector(".swiper-slide-active");
      const video = getVideoInSlide(activeSlideEl);
      if (!video) return;
      video.play().catch(() => {
        setToggleState(activeSlideEl, false);
      });
      video.addEventListener(
        "play",
        () => setToggleState(activeSlideEl, true),
        { once: true },
      );
    };

    mainSwiper.on("slideChangeTransitionEnd", () => {
      pauseAllVideos();
      playActiveVideoIfAny();
    });

    let prevSwipeIndex = mainSwiper.realIndex;
    let isFilterRedirecting = false;

    mainSwiper.on("slideChange", () => {
      if (isFilterRedirecting) {
        isFilterRedirecting = false;
        prevSwipeIndex = mainSwiper.realIndex;
        return;
      }

      const matchedIndices = getMatchingSlideIndices();
      const hasFilterActive = hasAnyVariantData && currentVariantTitle;
      const hasFilteredMatches =
        matchedIndices.length > 0 && matchedIndices.length < slideEls.length;

      if (hasFilterActive && hasFilteredMatches) {
        const currentIndex = mainSwiper.realIndex;
        if (!matchedIndices.includes(currentIndex)) {
          isFilterRedirecting = true;
          const direction = currentIndex > prevSwipeIndex ? "next" : "prev";
          const currentPos = matchedIndices.indexOf(prevSwipeIndex);
          if (currentPos === -1) {
            goToSlide(matchedIndices[0]);
          } else {
            let nextPos;
            if (direction === "next") {
              nextPos = (currentPos + 1) % matchedIndices.length;
            } else {
              nextPos =
                (currentPos - 1 + matchedIndices.length) %
                matchedIndices.length;
            }
            goToSlide(matchedIndices[nextPos]);
          }
          return;
        }
      }

      prevSwipeIndex = mainSwiper.realIndex;
    });

    const markGalleryReady = () => {
      requestAnimationFrame(() => {
        root.classList.add("is-ready");
      });
    };

    requestAnimationFrame(playActiveVideoIfAny);

    root.addEventListener("click", (event) => {
      const toggle = event.target.closest("[data-pill-gallery-video-toggle]");
      if (!toggle) return;

      const slideEl = toggle.closest(".swiper-slide");
      const video = getVideoInSlide(slideEl);
      if (!video) return;

      if (video.paused) {
        video.play().catch(() => {});
        setToggleState(slideEl, true);
      } else {
        video.pause();
        setToggleState(slideEl, false);
      }
    });

    if (
      root.querySelector(".image-magnify-hover") &&
      typeof enableZoomOnHover === "function"
    ) {
      const zoomMount =
        root.querySelector(".lalo-product-zoom") || ".lalo-product-zoom";
      enableZoomOnHover(1.5, { mount: zoomMount, container: root });

      const zoomIconEl = root.querySelector(".product-zoom-icon");

      const updateZoomIconForActiveSlide = () => {
        if (!zoomIconEl) return;
        const activeSlide = mainSwiper.slides[mainSwiper.activeIndex];
        const isVideo = !!(
          activeSlide && activeSlide.querySelector("[data-pill-gallery-video]")
        );
        root.classList.toggle("is-video-active", isVideo);
        if (isVideo) {
          closeZoomOverlay();
        }
      };

      mainSwiper.on("slideChange", updateZoomIconForActiveSlide);
      mainSwiper.on("slideChangeTransitionEnd", updateZoomIconForActiveSlide);
      updateZoomIconForActiveSlide();
    }

    const syncThumbsMaxHeight = () => {
      const mainEl = root.querySelector(".pill-gallery__main");
      const thumbs = root.querySelector(".pill-gallery__thumbs");
      if (!mainEl || !thumbs) return;

      const mainHeight = mainEl.offsetHeight;
      if (mainHeight > 0) {
        thumbs.style.setProperty("--pill-gallery-thumbs-max-height", `${mainHeight}px`);
        thumbs.classList.add("has-max-height");
      }
    };

    thumbEls.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        goToSlide(Number(thumb.dataset.slideIndex));
      });
    });

    syncThumbsMaxHeight();

    const resizeObserver = new ResizeObserver(() => {
      syncThumbsMaxHeight();
      updateThumbsScroll();
    });
    resizeObserver.observe(root);

    const thumbsContainer = root.querySelector(".pill-gallery__thumbs");
    const thumbsWrap = root.querySelector(".pill-gallery__thumbs-wrap");
    const thumbsChevron = root.querySelector("[data-pill-gallery-thumbs-scroll]");

    const thumbStep = () => {
      const firstThumb = root.querySelector(".pill-gallery__thumb");
      if (!firstThumb) return 110;
      const thumbHeight = firstThumb.offsetHeight || 98;
      const gap = parseFloat(getComputedStyle(thumbsContainer).rowGap || getComputedStyle(thumbsContainer).gap) || 12;
      return thumbHeight + gap;
    };

    const updateThumbsScroll = () => {
      if (!thumbsContainer || !thumbsWrap || !thumbsChevron) return;

      const canScrollDown = thumbsContainer.scrollTop < thumbsContainer.scrollHeight - thumbsContainer.clientHeight - 1;
      const canScrollUp = thumbsContainer.scrollTop > 1;

      thumbsWrap.classList.toggle("has-scroll", canScrollDown || canScrollUp);

      if (canScrollUp && !canScrollDown) {
        thumbsChevron.classList.add("is-flipped");
      } else {
        thumbsChevron.classList.remove("is-flipped");
      }

      thumbsChevron.setAttribute(
        "aria-label",
        canScrollUp && !canScrollDown ? "Scroll thumbnails up" : "Scroll thumbnails down"
      );
    };

    const scrollThumbsByStep = () => {
      if (!thumbsContainer || !thumbsChevron) return;
      const step = thumbStep();

      if (thumbsChevron.classList.contains("is-flipped")) {
        thumbsContainer.scrollBy({ top: -step, behavior: "smooth" });
      } else {
        thumbsContainer.scrollBy({ top: step, behavior: "smooth" });
      }
    };

    if (thumbsChevron) {
      thumbsChevron.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        scrollThumbsByStep();
      });
    }

    if (thumbsContainer) {
      thumbsContainer.addEventListener("scroll", () => {
        updateThumbsScroll();
      });
    }

    const onThumbVisibilityChange = () => {
      updateThumbsScroll();
    };

    const visibilityObserver = new MutationObserver(onThumbVisibilityChange);
    if (thumbsContainer) {
      visibilityObserver.observe(thumbsContainer, {
        attributes: true,
        attributeFilter: ["class"],
        subtree: true,
      });
    }

    updateThumbsScroll();

    if (hasPills) {
      const syncPillsToTag = (tag) => {
        pillButtons.forEach((pill) => {
          const isMatch = pill.dataset.pillTag === tag;
          pill.classList.toggle("is-active", isMatch);
          pill.setAttribute("aria-selected", isMatch);
          if (isMatch) {
            const pillsContainer = root.querySelector(".pill-gallery__pills");
            scrollElementIntoView(pill, pillsContainer, "horizontal");
          }
        });
      };

      const syncThumbsToTag = (tag, activeSlideIndex) => {
        const thumbsContainer = root.querySelector(".pill-gallery__thumbs");
        thumbEls.forEach((thumb) => {
          const slideIndex = Number(thumb.dataset.slideIndex);
          const matchesVariant =
            hasAnyVariantData && currentVariantTitle
              ? slideMatchesVariant(slideEls[slideIndex], currentVariantTitle)
              : true;
          thumb.classList.toggle("is-visible", matchesVariant);
          const isActive = matchesVariant && slideIndex === activeSlideIndex;
          thumb.classList.toggle("is-active", isActive);
          if (isActive) {
            scrollElementIntoView(thumb, thumbsContainer, "vertical");
          }
        });
      };

      pillButtons.forEach((pill) => {
        pill.addEventListener("click", () => {
          closeZoomOverlay();
          const tag = pill.dataset.pillTag;
          let targetIndex = -1;
          if (hasAnyVariantData && currentVariantTitle) {
            const matchedIndices = getMatchingSlideIndices();
            targetIndex = slideEls.findIndex(
              (s, i) => s.dataset.pillTag === tag && matchedIndices.includes(i),
            );
          }
          // Fallback to first slide in tag regardless of variant
          if (targetIndex === -1) {
            targetIndex = slideEls.findIndex((s) => s.dataset.pillTag === tag);
          }
          if (targetIndex > -1) {
            goToSlide(targetIndex);
          }
          syncThumbsToTag(tag, targetIndex > -1 ? targetIndex : 0);
          syncPillsToTag(tag);
        });
      });

      mainSwiper.on("slideChange", () => {
        const activeIndex = mainSwiper.realIndex;
        const tag = slideEls[activeIndex]?.dataset.pillTag;
        if (tag) {
          syncPillsToTag(tag);
          syncThumbsToTag(tag, activeIndex);
        }
      });

      const initialTag = slideEls[0]?.dataset.pillTag;
      syncThumbsToTag(initialTag, 0);
    } else {
      thumbEls.forEach((thumb) => thumb.classList.add("is-visible"));

      const highlightActiveThumb = (activeSlideIndex) => {
        const thumbsContainer = root.querySelector(".pill-gallery__thumbs");
        thumbEls.forEach((thumb) => {
          const slideIndex = Number(thumb.dataset.slideIndex);
          const matchesVariant =
            hasAnyVariantData && currentVariantTitle
              ? slideMatchesVariant(slideEls[slideIndex], currentVariantTitle)
              : true;
          thumb.classList.toggle("is-visible", matchesVariant);
          const isActive = matchesVariant && slideIndex === activeSlideIndex;
          thumb.classList.toggle("is-active", isActive);
          if (isActive) {
            scrollElementIntoView(thumb, thumbsContainer, "vertical");
          }
        });
      };

      mainSwiper.on("slideChange", () => {
        highlightActiveThumb(mainSwiper.realIndex);
      });

      highlightActiveThumb(0);
    }

    if (variantStarts) {
      let retryCount = 0;
      const MAX_RETRIES = 2;

      const initVariantFilter = () => {
        const vTitle = getVariantTitle();
        if (vTitle) {
          applyVariantFilter(vTitle);
        } else if (retryCount >= MAX_RETRIES) {
          revealGallery();
        }
        retryCount++;
      };

      initVariantFilter();

      if (!hasAnyVariantData) {
        setTimeout(initVariantFilter, 500);
        setTimeout(initVariantFilter, 1000);
      }
    } else {
      revealGallery();
    }
  });
});

